import { useContext } from 'react';

import {
  PreferencesContext,
  PreferencesType,
  SetPreferencesType,
} from '@/app/providers/preferences-provider/PreferencesProvider';
import { PreferencesContextType } from '@/app/providers/preferences-provider/withPreferences';

export default function usePreferences(): [PreferencesType, SetPreferencesType] {
  const { preferences, setPreferences } = useContext(PreferencesContext) as PreferencesContextType;

  return [preferences, setPreferences];
}
